import { CreateEvent, Event } from '../types/event'
import instance from '../../../api/axios'

export const loadEvents = async (): Promise<Event[]> => {
  const response = await instance.get('/events')
  return response.data
}

export const saveEvent = async (event: CreateEvent): Promise<Event> => {
  const response = await instance.post('/events', event)
  return response.data
}

export const modifyEvent = async (event: Event): Promise<Event> => {
  const response = await instance.put('/events', {
    id: event.id,
    title: event.title,
    description: event.description,
    note: event.note,
    type: event.type,
    priority: event.priority,
    periodicity: event.periodicity,
    dates: event.dates,
    tags: event.tags,
    notification: event.notification,
  })
  return response.data
}

export const removeEvent = async (id: string): Promise<string> => {
  const response = await instance.delete(`/events/${id}`)
  return response.data
}
